import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  subscription: null, // stores data.getFundingInsightsUserSubscription
  modalSubscription: null,
  displayLarge: true
};

const fundingSubscriptionSlice = createSlice({
  name: 'fundingSubscription',
  initialState,
  reducers: {
    setFundingSubscription: (state, action) => {
      state.subscription = action.payload;
    },
    setModalSubscriptionPlans: (state, action) => {
      state.modalSubscription = action.payload;
    },
    setDisplayLarge: (state, action) => {
      state.displayLarge = action.payload;
    },
    clearFundingSubscription: (state) => {
      state.subscription = null;
    }
  }
});

export const {
  setFundingSubscription,
  clearFundingSubscription,
  setModalSubscriptionPlans,
  setDisplayLarge
} = fundingSubscriptionSlice.actions;

export default fundingSubscriptionSlice.reducer;
